import {
  CANCEL_NOTIFY_GUESTS_OVERLAY,
  HIDE_NOTIFY_GUESTS_OVERLAY,
  SET_UPSELL_CONFIRMED,
  SET_UPSELL_MODAL_ORDER,
  SHOW_NOTIFY_GUESTS_OVERLAY,
} from './constants';

const initialState = {
  showNotifyGuestsOverlay: false,
  upsellConfirmed: false,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_NOTIFY_GUESTS_OVERLAY:
      return {
        ...state,
        showNotifyGuestsOverlay: true,
      };
    case CANCEL_NOTIFY_GUESTS_OVERLAY:
    case HIDE_NOTIFY_GUESTS_OVERLAY:
      return {
        ...state,
        showNotifyGuestsOverlay: false,
      };
    case SET_UPSELL_MODAL_ORDER:
      return {
        ...state,
        ...action.payload,
      };
    case SET_UPSELL_CONFIRMED:
      return {
        ...state,
        upsellConfirmed: action.payload,
      };
    default:
      return state;
  }
}
